import React from 'react';
import { Mail, Phone, Linkedin, FileText, Fingerprint, Github, History, Globe2, OctagonAlert, Flag, AlertTriangle, CheckCircle2, Info } from 'lucide-react';

const ICONS = { email: Mail, phone: Phone, linkedin: Linkedin, resume: FileText, identity: Fingerprint, github: Github, history: History, location: Globe2 };
const STATUS = {
  clean: { label: 'Clean', cls: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400', bar: 'bg-emerald-500' },
  review: { label: 'Review', cls: 'bg-amber-500/10 text-amber-700 dark:text-amber-400', bar: 'bg-amber-500' },
  flagged: { label: 'Flagged', cls: 'bg-red-500/10 text-red-700 dark:text-red-400', bar: 'bg-red-500' },
  not_provided: { label: 'Not checked', cls: 'bg-muted text-muted-foreground', bar: 'bg-border' },
};
const LEVEL = {
  critical: { icon: OctagonAlert, cls: 'text-red-600 dark:text-red-400 font-semibold' },
  flag: { icon: Flag, cls: 'text-red-600 dark:text-red-400' },
  review: { icon: AlertTriangle, cls: 'text-amber-600 dark:text-amber-400' },
  ok: { icon: CheckCircle2, cls: 'text-emerald-600 dark:text-emerald-400' },
  info: { icon: Info, cls: 'text-muted-foreground' },
};

export const SignalCard = ({ signal, index = 0 }) => {
  const Icon = ICONS[signal.key] || Info;
  const st = STATUS[signal.status] || STATUS.not_provided;
  return (
    <div className="relative rounded-xl border bg-card p-4 overflow-hidden animate-in fade-in slide-in-from-bottom-2 fill-mode-both"
      style={{ animationDelay: `${index * 60}ms`, animationDuration: '400ms' }} data-testid={`scout-signal-${signal.key}`}>
      <span className={`absolute left-0 top-0 bottom-0 w-1 ${st.bar}`} />
      <div className="flex items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2.5">
          <span className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center"><Icon className="h-4 w-4 text-foreground/80" /></span>
          <h4 className="text-sm font-semibold">{signal.label}</h4>
        </div>
        <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${st.cls}`} data-testid={`scout-signal-status-${signal.key}`}>{st.label}</span>
      </div>
      <ul className="space-y-1.5">
        {signal.findings.map((f, i) => {
          const L = LEVEL[f.level] || LEVEL.info;
          const FIcon = L.icon;
          return (
            <li key={i} className={`flex items-start gap-2 text-[13px] leading-snug ${L.cls}`}>
              <FIcon className="h-3.5 w-3.5 mt-0.5 shrink-0" /><span className={f.level === 'info' ? '' : 'text-foreground/90'}>{f.text}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SignalCard;
